import h from 'react-hyperscript';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { Dropdown, DropdownMenu, DropdownItem } from 'reactstrap';
import { Link } from 'react-router-dom';

import logo from '../../assets/img/logo-npo-banner-light.png';
import Avatar from '../Avatar/Avatar';
import Aux from '../Aux/Aux';
import Blink from '../Blink/Blink';
import { hasSuperAdminAccess } from '../../lib/authorization';
import { routeMap } from '../../routes';

class Header extends Component {
  static sidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-minimized');
  }

  static mobileSidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-mobile-show');
  }

  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false,
    };
  }

  login() {
    const { loginRequest } = this.props;

    loginRequest();
  }

  logout() {
    const { logoutRequest } = this.props;

    logoutRequest();
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  }

  render() {
    const { dropdownOpen: isProfileDropdownOpen } = this.state;
    const { data: { loading, me, me: { email, first: firstName, last: lastName, picture } = {} } = {} } = this.props;

    // In order to leverage cursor settings for bootstrap css, we have to put an href on link
    const href = 'javascript:;'; // eslint-disable-line no-script-url

    return h('header.app-header.navbar', [
      h(
        'button.navbar-toggler.mobile-sidebar-toggler.d-lg-none',
        {
          onClick: e => Header.mobileSidebarToggle(e),
          type: 'button',
        },
        '☰',
      ),
      h(Link, { className: 'navbar-brand', to: '/' }, [h('img', { className: 'navbar-brand-logo', src: logo })]),
      h('ul.nav.navbar-nav.hidden-md-down', [
        h('li.nav-item', [
          h('a.nav-link.navbar-toggler.sidebar-toggler', { href, onClick: e => Header.sidebarToggle(e) }, '☰'),
        ]),
      ]),
      h('ul.nav.navbar-nav.ml-auto', [
        h('li.nav-item.dropdown.nav-dropdown-profile', [
          loading && h(Blink),
          loading ||
            h(Dropdown, { isOpen: isProfileDropdownOpen, toggle: () => this.toggle() }, [
              h(
                'a.nav-link.dropdown-toggle.nav-link',
                {
                  href,
                  onClick: () => this.toggle(),
                  'data-toggle': 'dropdown',
                  role: 'button',
                  'aria-haspopup': 'true',
                  'aria-expanded': isProfileDropdownOpen,
                },
                [
                  hasSuperAdminAccess(me) && h(Aux, [h('i.fa.fa-key.text-muted'), ' ']),
                  h(Avatar, { email, firstName, lastName, picture }),
                  h('span.d-md-down-none', firstName || '    '),
                ],
              ),
              h(DropdownMenu, { className: 'dropdown-menu-right' }, [
                h(DropdownItem, { tag: Link, to: routeMap.USER_SETTINGS.path }, [h('i.fa.fa-wrench'), 'Settings']),
                h(DropdownItem, { onClick: e => this.logout(e) }, [h('i.fa.fa-lock'), h('span', 'Logout')]),
              ]),
            ]),
        ]),
      ]),
    ]);
  }
}

Header.defaultProps = {
  data: {
    email: null,
    first: null,
    last: null,
    picture: null,
  },
};

Header.propTypes = {
  loginRequest: PropTypes.func.isRequired,
  logoutRequest: PropTypes.func.isRequired,
  data: PropTypes.shape({
    me: PropTypes.shape({
      email: PropTypes.string,
      first: PropTypes.string,
      last: PropTypes.string,
      picture: PropTypes.string,
    }),
  }),
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js